<template>
    <el-card>
        <div slot="header">
            <span style="font-size: 18px; font-weight: bold">产品参数关联数据</span>
        </div>
        <!-- 1 -->
        <div class="product-param-rel-container">
            <!-- 左侧产品型号列表 -->
            <div class="type-panel">
                <div class="type-panel-header">
                    <span class="type-panel-title">产品类型</span>
                </div>
                <el-empty v-if="productList.length === 0 && !productLoading" description="暂无产品型号" />
                <div v-else class="template-scroll" @scroll="handleProductScroll">
                    <el-menu :default-active="activeProduct" class="rel-menu" @select="handleProductSelect">
                        <el-menu-item v-for="product in productList" :key="String(product.id)" :index="String(product.id)">
                            <el-tooltip :content="product.name" placement="right" :enterable="false" :open-delay="500">
                                <span class="template-name">{{ product.name }}</span>
                            </el-tooltip>
                        </el-menu-item>
                    </el-menu>
                    <div class="load-more">
                        <span v-if="productLoading">加载中...</span>
                        <span v-else-if="hasMoreProducts">上滑加载更多</span>
                        <span v-else-if="productList.length">已加载全部 {{ productTotal }} 个</span>
                    </div>
                </div>
            </div>

            <!-- 右侧参数关联内容 -->
            <div class="param-rel-wrapper">
                <div class="config-header">
                    <span class="config-title">参数关联配置</span>
                    <el-button type="primary" size="mini" icon="el-icon-plus" @click="handleAddGroup"> 添加参数分组 </el-button>
                </div>
                <el-empty v-if="!activeProduct" description="请先选择左侧产品型号" />
                <el-empty v-else-if="paramGroupList.length === 0" description="该产品型号暂无参数数据" />

                <div v-else>
                    <div class="param-group-block" v-for="group in paramGroupList" :key="String(group.paramGroupId)">
                        <div class="param-group-header">
                            <span class="param-group-name">{{ group.gourpName || (group.modelParamGroup || {}).name }}</span>
                            <div class="group-actions">
                                <el-button type="text" size="mini" class="group-delete-btn" @click="handleDeleteGroup(group)"> 删除参数分组 </el-button>
                                <el-button type="text" size="mini" class="group-add-btn" @click="handleAddParamItem(group)" > 增加参数子项 </el-button>
                            </div>
                        </div>
                        <el-empty v-if="!(group.paramRelItem || []).length" description="暂无参数子项" :image-size="60" />
                        <el-table v-else :data="group.paramRelItem" border stripe style="width: 100%" >
                            <el-table-column prop="itemName" label="参数名称" min-width="140" show-overflow-tooltip />
                            <el-table-column prop="itemParam" label="参数内容" min-width="320" show-overflow-tooltip />
                            <el-table-column label="排序" width="70" align="center">
                                <template slot-scope="scope">
                                    {{ (scope.row.modelParamItem || {}).sortOrder }}
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="110" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" style="color: #f56c6c" @click="handleDeleteRelItem(scope.row)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>

        <!-- 添加参数分组弹窗 -->
        <el-dialog title="添加参数分组" :visible.sync="groupDialogVisible" width="720px" :close-on-click-modal="false" @closed="resetGroupDialog">
            <div class="group-dialog-main">
                <!-- 左侧分组列表 -->
                <div v-loading="groupDialogLoading" class="group-option-panel">
                    <el-empty v-if="!groupDialogLoading && groupOptionList.length === 0" description="暂无参数分组" />
                    <div v-else class="group-option-scroll" @scroll="handleGroupOptionScroll">
                        <el-menu :default-active="selectedGroupId" class="rel-menu" @select="handleGroupOptionSelect">
                            <el-menu-item v-for="group in groupOptionList" :key="String(group.id)" :index="String(group.id)">
                                <el-tooltip :content="group.name" placement="right" :enterable="false" :open-delay="500">
                                    <span class="group-option-name">{{ group.name }}</span>
                                </el-tooltip>
                            </el-menu-item>
                        </el-menu>
                        <div class="load-more">
                            <span v-if="groupOptionLoading">加载中...</span>
                            <span v-else-if="hasMoreGroupOptions">上滑加载更多</span>
                            <span v-else-if="groupOptionList.length">已加载全部 {{ groupOptionTotal }} 个</span>
                        </div>
                    </div>
                </div>
                <!-- 右侧参数子项列表 -->
                <div v-loading="paramItemLoading" class="param-item-panel">
                    <el-empty v-if="!selectedGroupId" description="请先选择左侧参数分组" />
                    <el-empty v-else-if="!paramItemLoading && paramItemList.length === 0" description="该分组暂无可选参数子项" />
                    <el-menu v-else :key="selectedGroupId" :default-active="selectedItemId" class="rel-menu" @select="handleParamItemSelect">
                        <el-menu-item v-for="item in paramItemList" :key="String(item.id)" :index="String(item.id)">
                            <span class="group-option-name">{{ item.name }}</span>
                            <el-tooltip class="param-item-tooltip" :content="item.param" placement="top" :enterable="false" :open-delay="500">
                                <span class="param-item-param">{{ item.param }}</span>
                            </el-tooltip>
                        </el-menu-item>
                    </el-menu>
                </div>
            </div>
            <div slot="footer">
                <el-button @click="groupDialogVisible = false">取 消</el-button>
                <el-button type="primary" :loading="groupSubmitLoading" :disabled="!selectedGroupId || !selectedItemId" @click="handleGroupSubmit" >保 存</el-button>
            </div>
        </el-dialog>

        <!-- 增加参数子项弹窗 -->
        <el-dialog :title="`增加参数子项 - ${currentGroupName}`" :visible.sync="paramItemDialogVisible" width="520px" :close-on-click-modal="false" @closed="resetParamItemDialog" >
            <div v-loading="paramItemLoading" class="group-dialog-body">
                <el-empty
                    v-if="!paramItemLoading && availableParamItemList.length === 0"
                    :description="paramItemList.length === 0 ? '该分组暂无可选参数子项' : '该分组子项已全部关联，请到分组数据中新增参数子项'"
                />
                <el-menu v-else :default-active="currentItemId" class="rel-menu" @select="handleCurrentItemSelect">
                    <el-menu-item v-for="item in availableParamItemList" :key="String(item.id)" :index="String(item.id)">
                        <span class="group-option-name">{{ item.name }}</span>
                        <span class="param-item-param">{{ item.param }}</span>
                    </el-menu-item>
                </el-menu>
            </div>
            <div slot="footer">
                <el-button @click="paramItemDialogVisible = false">取 消</el-button>
                <el-button type="primary" :loading="paramItemSubmitLoading" :disabled="!currentItemId" @click="handleParamItemSubmit">保 存</el-button>
            </div>
        </el-dialog>
    </el-card>
</template>

<script>
import { productModelList, productParamGroupModelDetail, productParamGroupList, productParamGroupDetail, productParamRelAdd, productParamRelDelete, productParamRelDeleteByModelIdAndGroupId } from '@/api/quote'

export default {
    name: 'productParamRel',
    data() {
        return {
            activeProduct: '',
            paramGroupList: [],
            productList: [],
            productLoading: false,
            productPage: 1,
            productPageSize: 20,
            productTotal: 0,
            groupDialogVisible: false,
            groupDialogLoading: false,
            groupOptionLoading: false,
            groupOptionPage: 1,
            groupOptionPageSize: 20,
            groupOptionTotal: 0,
            groupSubmitLoading: false,
            groupOptionList: [],
            selectedGroupId: '',
            selectedItemId: '',
            paramItemDialogVisible: false,
            paramItemLoading: false,
            paramItemSubmitLoading: false,
            paramItemList: [],
            currentGroupId: '',
            currentGroupName: '',
            currentItemId: '',
            currentRelItemIds: []
        }
    },
    computed: {
        // 过滤掉该产品型号下已关联的参数子项
        availableParamItemList() {
            const relIds = (this.currentRelItemIds || []).map(id => String(id))
            return (this.paramItemList || []).filter(item => !relIds.includes(String(item.id)))
        },
        hasMoreProducts() {
            return this.productList.length < this.productTotal
        },
        hasMoreGroupOptions() {
            return this.groupOptionList.length < this.groupOptionTotal
        }
    },
    mounted() {
        this.getProductModelList()
    },
    methods: {
        // 获取产品型号列表（左侧菜单，滚动分页，append 时追加下一页）
        getProductModelList(append = false) {
            if (this.productLoading) return
            this.productLoading = true
            productModelList({
                filter: [],
                sorted: [{ name: 'sortOrder', type: 'ASC' }],
                current: append ? this.productPage : 1,
                size: this.productPageSize
            }).then(res => {
                if (res.success && res.result) {
                    const records = res.result.records || []
                    this.productList = append ? this.productList.concat(records) : records
                    this.productTotal = res.result.total || 0
                }
            }).catch(error => {
                console.error('获取产品型号列表失败：', error)
                if (!append) {
                    this.productList = []
                    this.productTotal = 0
                }
            }).finally(() => {
                this.productLoading = false
            })
        },
        // 左侧产品类型滚动到底部时加载下一页
        handleProductScroll(event) {
            const el = event.target
            if (el.scrollTop + el.clientHeight >= el.scrollHeight - 40) {
                this.loadMoreProducts()
            }
        },
        // 加载下一页产品型号（追加到列表尾部）
        loadMoreProducts() {
            if (this.productLoading || !this.hasMoreProducts) return
            this.productPage += 1
            this.getProductModelList(true)
        },
        // 处理产品型号选择
        handleProductSelect(index) {
            this.activeProduct = index
            this.getProductParamGroupModelDetail(index)
        },
        // 打开添加参数分组弹窗
        handleAddGroup() {
            if (!this.activeProduct) {
                this.$message.warning('请先选择左侧产品型号')
                return
            }
            this.selectedGroupId = ''
            this.selectedItemId = ''
            this.groupOptionList = []
            this.groupDialogVisible = true
            this.getParamGroupOptions()
        },
        // 获取可选参数分组列表（滚动分页，append 时追加下一页）
        getParamGroupOptions(append = false) {
            if (append) {
                if (this.groupOptionLoading || !this.hasMoreGroupOptions) return
                this.groupOptionLoading = true
            } else {
                this.groupDialogLoading = true
            }
            productParamGroupList({
                filter: [],
                sorted: [{ name: 'sortOrder', type: 'ASC' }],
                current: append ? this.groupOptionPage : 1,
                size: this.groupOptionPageSize
            }).then(res => {
                if (res.success && res.result) {
                    const records = res.result.records || []
                    this.groupOptionList = append ? this.groupOptionList.concat(records) : records
                    this.groupOptionTotal = res.result.total || 0
                }
            }).catch(error => {
                console.error('获取参数分组列表失败：', error)
                this.$message.error('获取参数分组列表失败')
                if (!append) {
                    this.groupOptionList = []
                    this.groupOptionTotal = 0
                }
            }).finally(() => {
                this.groupDialogLoading = false
                this.groupOptionLoading = false
            })
        },
        // 分组列表滚动到底部时加载下一页
        handleGroupOptionScroll(event) {
            const el = event.target
            if (el.scrollTop + el.clientHeight >= el.scrollHeight - 40) {
                this.groupOptionPage += 1
                this.getParamGroupOptions(true)
            }
        },
        // 选择参数分组
        handleGroupOptionSelect(index) {
            this.selectedGroupId = index
            this.selectedItemId = ''
            this.loadParamItems(Number(index))
        },
        // 选择参数子项
        handleParamItemSelect(index) {
            this.selectedItemId = index
        },
        // 关闭弹窗后重置数据
        resetGroupDialog() {
            this.selectedGroupId = ''
            this.selectedItemId = ''
            this.groupOptionList = []
            this.groupOptionPage = 1
            this.groupOptionTotal = 0
            this.paramItemList = []
        },
        // 打开增加参数子项弹窗并加载对应分组详情
        handleAddParamItem(group) {
            const groupId = group.paramGroupId 
            this.currentGroupId = String(groupId)
            this.currentGroupName = group.gourpName || (group.modelParamGroup || {}).name
            this.currentItemId = ''
            this.currentRelItemIds = (group.paramRelItem || []).map(item => item.paramItemId || (item.modelParamItem || {}).id)
            this.paramItemList = []
            this.paramItemDialogVisible = true
            this.loadParamItems(groupId)
        },
        // 根据分组id获取分组详情（含参数子项）
        loadParamItems(groupId) {
            this.paramItemList = []
            this.paramItemLoading = true
            productParamGroupDetail(groupId).then(res => {
                if (res.success && res.result) {
                    this.paramItemList = res.result.modelParamItemList || []
                }
            }).catch(error => {
                console.error('获取参数分组详情失败：', error)
                this.$message.error('获取参数分组详情失败')
            }).finally(() => {
                this.paramItemLoading = false
            })
        },
        // 选择待添加的参数子项
        handleCurrentItemSelect(index) {
            this.currentItemId = index
        },
        // 关闭增加参数子项弹窗后重置数据
        resetParamItemDialog() {
            this.currentItemId = ''
            this.currentRelItemIds = []
            this.paramItemList = []
            this.currentGroupId = ''
            this.currentGroupName = ''
        },
        // 保存参数子项关联
        handleParamItemSubmit() {
            if (!this.activeProduct || !this.currentGroupId || !this.currentItemId) return
            this.submitRel({
                groupId: this.currentGroupId,
                itemId: this.currentItemId,
                dialogKey: 'paramItemDialogVisible',
                loadingKey: 'paramItemSubmitLoading',
                errorText: '添加参数子项失败'
            })
        },
        // 保存参数分组关联
        handleGroupSubmit() {
            if (!this.selectedGroupId || !this.selectedItemId) return
            this.submitRel({
                groupId: this.selectedGroupId,
                itemId: this.selectedItemId,
                dialogKey: 'groupDialogVisible',
                loadingKey: 'groupSubmitLoading',
                errorText: '添加参数分组失败'
            })
        },
        // 保存参数关联（分组/子项共用）
        async submitRel({ groupId, itemId, dialogKey, loadingKey, errorText }) {
            this[loadingKey] = true
            try {
                const res = await productParamRelAdd({
                    modelId: Number(this.activeProduct),
                    paramGroupId: Number(groupId),
                    paramItemId: Number(itemId),
                    sortOrder: 0
                })
                if (res.success) {
                    this.$message.success('添加成功')
                    this[dialogKey] = false
                    this.getProductParamGroupModelDetail(this.activeProduct)
                } else {
                    this.$message.error(res.message || '添加失败')
                }
            } catch (error) {
                console.error(`${errorText}：`, error)
                this.$message.error(errorText)
            } finally {
                this[loadingKey] = false
            }
        },
        // 删除产品型号下的参数分组关联（二次确认）
        handleDeleteGroup(group) {
            const groupId = group.paramGroupId
            const groupName = group.gourpName
            if (!this.activeProduct || !groupId) {
                this.$message.error('未获取到产品型号或参数分组id，无法删除')
                return
            }
            this.$confirm(`确定删除参数分组「${groupName}」及其下所有参数子项吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                return productParamRelDeleteByModelIdAndGroupId(this.activeProduct, groupId).then(res => {
                    if (res.success) {
                        this.$message.success('删除成功')
                        this.getProductParamGroupModelDetail(this.activeProduct)
                    } else {
                        this.$message.error(res.message || '删除失败')
                    }
                })
            }).catch(error => {
                if (error !== 'cancel' && error !== 'close') {
                    console.error('删除参数分组关联失败：', error)
                    this.$message.error('删除参数分组关联失败')
                }
            })
        },
        // 删除参数子项关联（二次确认）
        handleDeleteRelItem(row) {
            const relId = row.relId
            if (!relId) {
                this.$message.error('未获取到关联id，无法删除')
                return
            }
            this.$confirm(`确定删除该参数子项「${row.itemName || ''}」吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                return productParamRelDelete(relId).then(res => {
                    if (res.success) {
                        this.$message.success('删除成功')
                        this.getProductParamGroupModelDetail(this.activeProduct)
                    } else {
                        this.$message.error(res.message || '删除失败')
                    }
                })
            }).catch(error => {
                if (error !== 'cancel' && error !== 'close') {
                    console.error('删除参数子项关联失败：', error)
                    this.$message.error('删除参数子项关联失败')
                }
            })
        },
        // 根据产品型号id获取参数分组（含参数子项）
        getProductParamGroupModelDetail(modelId) {
            this.paramGroupList = []
            productParamGroupModelDetail(modelId).then(res => {
                if (res.success && res.result) {
                    this.paramGroupList = res.result
                }
            }).catch(error => {
                console.error('获取产品型号参数分组失败：', error)
                this.$message.error('获取产品型号参数分组失败')
            })
        }
    }
}
</script>

<style scoped>
.product-param-rel-container {
    display: flex;
    align-items: flex-start;
    min-height: 560px;
    flex-wrap: nowrap;
}

/* 左侧产品类型面板 */
.type-panel {
    width: 220px;
    min-width: 220px;
    flex-shrink: 0;
    padding-right: 16px;
    display: flex;
    flex-direction: column;
}

.type-panel-header {
    padding: 0 4px 12px;
}

.type-panel-title {
    font-size: 15px;
    font-weight: bold;
    color: #303133;
}

.template-scroll {
    flex: 1;
    max-height: 560px;
    padding-right: 4px;
    overflow-x: hidden;
    overflow-y: auto;
}

.template-name {
    display: block;
    min-width: 0;
    font-size: 13px;
    color: #606266;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.load-more {
    padding: 10px 0;
    text-align: center;
    font-size: 12px;
    color: #909399;
}

/* 右侧参数关联面板 */
.param-rel-wrapper {
    flex: 1;
    min-width: 0;
    padding-left: 20px;
    overflow-x: auto;
}

.config-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 12px;
    margin-bottom: 16px;
    border-bottom: 1px solid #ebeef5;
}

.config-title {
    font-size: 15px;
    font-weight: bold;
    color: #303133;
}

.param-group-block {
    padding: 12px 16px 16px;
    margin-bottom: 16px;
    background-color: #fafbfc;
    border: 1px solid #ebeef5;
    border-radius: 4px;
}

.param-group-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
}

.param-group-name {
    padding-left: 8px;
    font-size: 14px;
    font-weight: bold;
    color: #303133;
    border-left: 3px solid #409eff;
}

.group-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.group-add-btn {
    padding: 0;
    font-size: 13px;
}

.group-delete-btn {
    padding: 0;
    font-size: 13px;
    color: #f56c6c;
}

.param-group-block .group-actions .el-button {
    margin-left: 0;
}

.group-dialog-body {
    max-height: 420px;
    min-height: 120px;
    padding-right: 6px;
    overflow-y: auto;
}

.group-dialog-main {
    display: flex;
    min-height: 320px;
}

.group-option-panel,
.param-item-panel {
    max-height: 420px;
    min-height: 320px;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0 6px 0 0;
}

.group-option-panel {
    width: 220px;
    min-width: 220px;
    flex-shrink: 0;
    padding-right: 12px;
    border-right: 1px solid #ebeef5;
}

.group-option-scroll {
    max-height: 420px;
    overflow-x: hidden;
    overflow-y: auto;
}

.param-item-panel {
    flex: 1;
    min-width: 0;
    padding: 0 0 0 12px;
}

.param-item-tooltip {
    flex: 1;
    min-width: 0;
    overflow: hidden;
}

.param-item-param {
    display: block;
    min-width: 0;
    font-size: 12px;
    color: #909399;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.group-option-name {
    display: block;
    flex: 1;
    min-width: 0;
    font-size: 14px;
    color: #303133;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* 选中列表统一使用 el-menu */
.rel-menu {
    border-right: none;
    background-color: transparent;
}

.rel-menu .el-menu-item {
    display: flex;
    align-items: center;
    min-width: 0;
    height: auto;
    min-height: 38px;
    line-height: 1.5;
    padding: 8px 12px;
    margin-bottom: 8px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background-color: #fff;
}

.rel-menu .el-menu-item:hover {
    border-color: #c6e2ff;
    background-color: #f5f7fa;
}

.rel-menu .el-menu-item.is-active {
    border-color: #409eff;
    background-color: #ecf5ff;
}

.rel-menu .el-menu-item.is-active .template-name,
.rel-menu .el-menu-item.is-active .group-option-name {
    color: #409eff;
}
</style>